import axios from '../../services/axios.service';
import { getEndpointBase } from '../../services/api.service';
import { RegionFetchParams } from './Region.type';

let listRequest: any = null;
let idRequest: any = null;

const regionService = {
  getList: ({ page, search, ids }: RegionFetchParams) => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase(`region`), {
      cancelToken: listRequest.token,
      params: {
        page,
        q: search,
        filter: {
          ids,
        },
      },
    });
  },
  getById(id: number | string) {
    idRequest && idRequest.cancel();
    idRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase(`region/${id}`), {
      cancelToken: idRequest.token,
    });
  },
};

export default regionService;
